import React from 'react';
import RangeGauge from 'ui/RangeGauge';
import { invalidAssessmentError } from './helpers.js';

const WordsPerMinuteModule = ({
  assessmentData,
  assessmentError,
  componentIndex,
}) => {
  const formattedWpm = Math.round(assessmentData?.formattedAssistedGrade?.wpm);

  const between = (x, min, max) => {
    return x >= min && x <= max;
  };

  const paceQualitativeValue = () => {
    if (between(formattedWpm, 0, 100)) {
      return t('automated_analysis.words_per_minute.too_slow');
    }
    if (between(formattedWpm, 101, 120)) {
      return t('automated_analysis.words_per_minute.slow');
    }
    if (between(formattedWpm, 121, 160)) {
      return t('automated_analysis.words_per_minute.good');
    }
    if (between(formattedWpm, 161, 180)) {
      return t('automated_analysis.words_per_minute.fast');
    }
    if (between(formattedWpm, 181, 350)) {
      return t('automated_analysis.words_per_minute.too_fast');
    }
    return null;
  };

  const invalidWpm =
    !assessmentData?.formattedAssistedGrade?.wpm &&
    assessmentData?.formattedAssistedGrade?.wpm !== 0;

  return (
    <RangeGauge
      ranges={[
        {
          type: 'danger',
          width: 15,
          startingThreshold: 0,
          endingThreshold: 100,
        },
        {
          type: 'caution',
          width: 15,
          startingThreshold: 101,
          endingThreshold: 120,
        },
        {
          type: 'safe',
          width: 40,
          startingThreshold: 121,
          endingThreshold: 160,
        },
        {
          type: 'caution',
          width: 15,
          startingThreshold: 161,
          endingThreshold: 180,
        },
        {
          type: 'danger',
          width: 15,
          startingThreshold: 181,
          endingThreshold: 350,
        },
      ]}
      value={formattedWpm}
      overallEndThreshold={350}
      componentIndex={componentIndex}
      qualitativeValue={paceQualitativeValue()}
      quantitativeValue={
        assessmentData.assistedGradingStatus === 'complete' &&
        !invalidWpm &&
        !assessmentError &&
        `${formattedWpm} wpm`
      }
      tooltipText={t(
        'automated_analysis.words_per_minute.tooltip_grading_station',
      )}
      featureName={t('automated_analysis.words_per_minute.title')}
      rangesCanBeRendered={
        assessmentData.assistedGradingStatus === 'complete' || !invalidWpm
      }
      status={assessmentData.assistedGradingStatus}
      error={assessmentError}
      invalidValue={invalidWpm}
      invalidAssessmentError={invalidAssessmentError(assessmentData)}
    />
  );
};

export default WordsPerMinuteModule;
